import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';

import ItemGrid from 'Common/Grid/ItemGrid';
import Button from 'Common/CustomButtons/Button';
import EmailDialog from './EmailDialog';
import { loadTemplateByPhases } from 'Actions/email';
import { loadPhases, loadStatuses, changePhase, changeStatus, authorDecision } from 'Actions/submission';
import {
    PHASES_LIST,
    PHASE_PUBLISHED,
    PROCESS_STATUS_AUTHOR_REVISION,
    PROCESS_STATUS_IN_PROGRESS,
    ROLE_ADMIN,
    ROLE_EDITORIAL,
    ROLE_CHIEF_EDITORIAL,
    ROLE_AUTHOR,
    PHASE_PEER_REVIEW,
    PHASE_AUTHOR_DECISION,
    PROCESS_STATUS_REJECTED,
    ROLE_EDITORIAL_BOARD,
    PHASE_DESK_REVIEW,
    PHASE_PEER_REVIEW_HANDLE,
    ROLE_REVIEWER,
    FILE_TYPE_REVIEW,
    FILE_TYPE_MANUSCRIPT_BLIND,
    TYPE_EXTERNAL,
    PHASE_DECISION_MAKING,
} from 'Constants';
import { aclDecorator, lightboxDecorator } from 'Decorators';

@connect(store => ({
    statuses: store.submissionStatuses.data,
    data: store.submissionData.submission,
    templates: store.emailTemplate.templates,
    attachments: store.submissionAttachments.attachments
}), dispatch => ({
    loadPhases: () => dispatch(loadPhases()),
    loadStatuses: () => dispatch(loadStatuses()),
    changePhase: (id, data) => dispatch(changePhase(id, data)),
    changeStatus: (id, data) => dispatch(changeStatus(id, data)),
    loadTemplateByPhases: (phases) => dispatch(loadTemplateByPhases(phases)),
    authorDecision: (id, decision) => dispatch(authorDecision(id, decision)),
}))
@aclDecorator()
@lightboxDecorator({
    title: 'title.warning'
})
export default class Workflow extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        isPhase: PropTypes.func.isRequired,
        isStatus: PropTypes.func.isRequired,
        loadStatuses: PropTypes.func.isRequired,
        changePhase: PropTypes.func.isRequired,
        changeStatus: PropTypes.func.isRequired,
        loadTemplateByPhases: PropTypes.func.isRequired,
        submission: PropTypes.object,
        phasesList: PropTypes.array.isRequired,
        statuses: PropTypes.array,
        data: PropTypes.object,
        templates: PropTypes.object,
        isOneOf: PropTypes.func.isRequired,
        is: PropTypes.func.isRequired,
        toggleAssignReviewers: PropTypes.func.isRequired,
        authorDecision: PropTypes.func.isRequired,
        openLightbox: PropTypes.func.isRequired,
        roundId: PropTypes.number,
        attachments: PropTypes.object,
        isReviewFinished: PropTypes.bool,
        finishReview: PropTypes.func.isRequired,
    };

    state = {
        key: Math.random(),
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const { isPhase, isStatus, loadStatuses, loadTemplateByPhases } = this.props;
        loadStatuses();
        if (!isPhase(PHASE_PUBLISHED) && !isStatus(PROCESS_STATUS_REJECTED)) {
            loadTemplateByPhases(
                [
                    PROCESS_STATUS_REJECTED,
                    PROCESS_STATUS_AUTHOR_REVISION,
                ].concat(isPhase(PHASE_AUTHOR_DECISION) ? [PHASE_PUBLISHED] : [])
                    .concat(isPhase(PHASE_DESK_REVIEW) || isPhase(PHASE_PEER_REVIEW) ? [PHASE_PEER_REVIEW, PHASE_PEER_REVIEW_HANDLE] : [])
                    .concat(isPhase(PHASE_DECISION_MAKING) || isPhase(PHASE_AUTHOR_DECISION) ? [PHASE_AUTHOR_DECISION] : [])
            );
        }
    }

    handleChangePhase = (phase, isPeerReview = false) => {
        return (email, emailAdditional=null) => {
            const { submission, changePhase, toggleAssignReviewers } = this.props;
            if (isPeerReview) {
                toggleAssignReviewers(email, emailAdditional);
            } else {
                changePhase(submission.id, {phase, email});
                this.setState({key: Math.random()});
            }
        };
    };

    handleChangeStatus = (status, isReviewer = 0) => {
        const { finishReview } = this.props;
        return (email = {}) => {
            if (isReviewer) {
                finishReview();
            }

            const { submission, changeStatus } = this.props;
            changeStatus(submission.id, {status, email, isReviewer});
            this.setState({key: Math.random()});
        };
    };

    handleAuthorDecision = (decision) => {
        return () => {
            const { submission, authorDecision } = this.props;
            authorDecision(submission.id, { decision });
            this.setState({ key: Math.random() });
        };
    };

    isAdminUser() {
        const { isOneOf } = this.props;
        return isOneOf([ROLE_ADMIN, ROLE_EDITORIAL, ROLE_CHIEF_EDITORIAL]);
    }

    isTemplateExists(template) {
        const { templates } = this.props;
        return templates && templates[template];
    }

    getAdminButtons() {
        const { isPhase, isStatus, phasesList, data: submission, templates, openLightbox, attachments } = this.props;

        const currentPhase = phasesList.find(phase => phase.alias === submission.status.alias);
        const nextPhase = phasesList.find(phase => {
            return phase.alias === PHASES_LIST[PHASES_LIST.indexOf(submission.status.alias) + 1];
        });
        const hasBlindManuscript = attachments && attachments[FILE_TYPE_MANUSCRIPT_BLIND];

        return (
            <div>
                {
                    nextPhase && nextPhase.alias === PHASE_PEER_REVIEW && this.isTemplateExists(PHASE_PEER_REVIEW) &&
                        <Button
                            color="success"
                            right
                            type={'button'}
                            onClick={() => this.handleChangePhase(nextPhase.id, true)(templates[PHASE_PEER_REVIEW], templates[PHASE_PEER_REVIEW_HANDLE])}
                            disabled={!hasBlindManuscript}
                        >
                            { nextPhase.status }
                        </Button>
                }

                {
                    nextPhase && nextPhase.alias === PHASE_AUTHOR_DECISION && this.isTemplateExists(PHASE_AUTHOR_DECISION) &&
                    <EmailDialog
                        template={ templates[PHASE_AUTHOR_DECISION] }
                        submissionId={ submission.id }
                        openBtnText={ nextPhase.status }
                        openBtnColor='success'
                        openBtnRight
                        onSubmit={this.handleChangePhase(nextPhase.id)}
                        isInitValues={true}
                        initUsers={ [submission.user_id] }
                    />
                }

                {
                    nextPhase && ![PHASE_PEER_REVIEW, PHASE_AUTHOR_DECISION].includes(nextPhase.alias) &&
                        <Button
                            color="success"
                            right
                            type={'button'}
                            onClick={() => openLightbox(
                                this.handleChangePhase(nextPhase.id),
                                this.context.intl.formatMessage({ id: 'alert.submission.phase.change' }, {phase: nextPhase.status})
                            )}
                        >
                            { nextPhase.status }
                        </Button>
                }

                {
                    isPhase(PHASE_PEER_REVIEW) && this.isTemplateExists(PHASE_PEER_REVIEW) &&
                        <Button
                            color="info"
                            right
                            type={'button'}
                            onClick={() => this.handleChangePhase(currentPhase.id, true)(templates[PHASE_PEER_REVIEW], templates[PHASE_PEER_REVIEW_HANDLE])}
                            disabled={!hasBlindManuscript}
                        >
                            { <FormattedMessage id={'button.submission.new_round'} /> }
                        </Button>
                }

                {
                    this.isTemplateExists(PROCESS_STATUS_AUTHOR_REVISION) &&
                    isStatus(PROCESS_STATUS_IN_PROGRESS) && !isPhase(PHASE_AUTHOR_DECISION) &&
                    <EmailDialog
                        template={ templates[PROCESS_STATUS_AUTHOR_REVISION] }
                        submissionId={ submission.id }
                        openBtnRight
                        openBtnText={<FormattedMessage id={'button.submission.to_revision'} />}
                        onSubmit={this.handleChangeStatus(PROCESS_STATUS_AUTHOR_REVISION)}
                        isInitValues={true}
                        initUsers={[ submission.user_id ]}
                        allowedUsers={(submission.reviewers ? submission.reviewers.filter(reviewer => reviewer.type !== TYPE_EXTERNAL).map(reviewer => reviewer.user_id) : [])
                            .concat([ submission.user_id ])}
                    />
                }

                {
                    this.isTemplateExists(PROCESS_STATUS_REJECTED) &&
                    <EmailDialog
                        template={ templates[PROCESS_STATUS_REJECTED] }
                        submissionId={ submission.id }
                        openBtnText={<FormattedMessage id={'button.submission.reject'} />}
                        openBtnColor='danger'
                        openBtnRight
                        onSubmit={this.handleChangeStatus(PROCESS_STATUS_REJECTED)}
                        isInitValues={true}
                        initUsers={ [submission.user_id] }
                    />
                }
            </div>
        );
    }

    getAuthorButtons() {
        const { isPhase, isStatus, data: submission } = this.props;
        return (isStatus(PROCESS_STATUS_AUTHOR_REVISION) ?
            <Button
                color="success"
                right
                type={'button'}
                onClick={this.handleChangeStatus(PROCESS_STATUS_IN_PROGRESS)}
            >
                <FormattedMessage id={'button.submission.to_progress'} />
            </Button> :
            (isPhase(PHASE_AUTHOR_DECISION) && submission.author_decision === null && (
                <span>
                    <Button
                        color="success"
                        right
                        type={'button'}
                        onClick={this.handleAuthorDecision(1)}
                    >
                        <FormattedMessage id={'button.decision.agree'} />
                    </Button>
                    <Button
                        color="danger"
                        right
                        type={'button'}
                        onClick={this.handleAuthorDecision(0)}
                    >
                        <FormattedMessage id={'button.decision.decline'} />
                    </Button>
                </span>
            ))
        );
    }

    getReviewerButtons() {
        const { isPhase, attachments, isReviewFinished } = this.props;
        if (!isPhase(PHASE_PEER_REVIEW) || isReviewFinished)
            return null;

        return (<Button
            color="success"
            right
            type={'button'}
            onClick={this.handleChangeStatus(PROCESS_STATUS_IN_PROGRESS, 1)}
            disabled={!attachments || !attachments[FILE_TYPE_REVIEW]}
        >
            <FormattedMessage id={'button.submission.to_progress'} />
        </Button>);
    }

    render () {
        const { isPhase, isStatus, data: submission, is, isOneOf } = this.props;
        const { key } = this.state;
        if (!submission || !submission.status_id) {
            return null;
        }

        return (
            <div key={key}>
                { !isPhase(PHASE_PUBLISHED) && !isStatus(PROCESS_STATUS_REJECTED) &&
                    <Grid container direction="row" justify="center">
                        <ItemGrid
                            xs={ 12 }
                            sm={ 12 }
                            md={ 12 }
                            className='workflow-btns-wrap'
                        >
                            { this.isAdminUser() && this.getAdminButtons() }

                            { is(ROLE_AUTHOR) && this.getAuthorButtons() }

                            { isOneOf([ROLE_REVIEWER, ROLE_EDITORIAL_BOARD]) && this.getReviewerButtons() }
                        </ItemGrid>
                    </Grid>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/Workflow.jsx